var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[(!_vm.canLearn && this.projectObj.id)?_c('subject-advance'):_vm._e(),(_vm.canLearn && this.projectObj.id)?_c('subject-home'):((!_vm.projectObj || (_vm.projectObj && !_vm.projectObj.id)))?_c('no-course-page',{attrs:{"tipTxt":"当前项目不存在或尚未发布"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }